import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const BusinessInvestmentExecSummary = ({ investorResult, yearlyData, params }) => {
  if (!investorResult || !yearlyData) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  const finalYear = yearlyData[yearlyData.length - 1];

  return (
    <div className="bg-purple-50 p-6 rounded-lg space-y-2">
      <ul className="list-disc list-inside text-gray-700 text-sm space-y-1">
        <li><strong>Term:</strong> {params.termYears} Years</li>
        <li><strong>Initial Investment:</strong> {formatCurrency(params.propertyValue)}</li>
        <li><strong>Business Revenue Growth:</strong> {params.businessRevenueGrowthRate}% annually</li>
        <li><strong>Valuation Multiple:</strong> {params.businessAppreciationMultiple}x</li>
        <li><strong>Final Business Value:</strong> {formatCurrency(finalYear.businessValue)}</li>
        <li><strong>Total ROI:</strong> {investorResult.totalROI}%</li>
        <li><strong>Annualized ROI:</strong> {investorResult.annualizedROI}%</li>
        <li><strong>IRR Estimate:</strong> {investorResult.irrEstimate}%</li>
      </ul>
    </div>
  );
};

export default BusinessInvestmentExecSummary;
